import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import MonthlyTasksTable from '../Components/MonthlyTasksTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [task, setSelectedTask] = useState(undefined);
    const [taskName, setTaskName] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: tasks, loading }, refetch] = useAxios("/internal/cobrand/monthly-tasks");

    if (loading) return <Spinner className="absolute-center" label="Loading Domains..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Redirect Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <MonthlyTasksTable
                tasks={tasks && tasks.length > 0 ? tasks.sort((a, b) => b.themedMonthlyTaskId - a.themedMonthlyTaskId) : []}
                setSelectedTask={setSelectedTask}
                setSelectedTaskName={setTaskName}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, label) => {
                    setSelectedTask(id);
                    setTaskName(label || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`internal/cobrand/monthly-task/delete/${task}/`}
                resourceName={taskName}
                resourceType="monthly task"
                confirmationValue={taskName || undefined}
            />
        </>
    );
};

export default DefaultPage;
